<ng-template #ibexsmartFormField let-key="key">
  <ng-container *ngIf="key === 'matchIds' && hotelData?.length > 0">
    <div class="select-wrapper">
      <mat-select [(ngModel)]="myPackage.ibexApp.matchIds['hotellerie-suisse']" placeholder="{{'packages.ibexsmart.matchIds' | translate}}">
        <mat-option [value]=""><b>None</b></mat-option>
        <mat-option *ngFor="let hotel of hotelData" [value]="hotel.id">
          <b>{{hotel.name}}</b>
          <span *ngIf="hotel.addresses && hotel.addresses.length">- {{hotel.addresses[0].city}}</span>
        </mat-option>
      </mat-select>
    </div>
  </ng-container>
  <smart-input *ngIf="key !== 'matchIds'" [(model)]="myPackage" [hasTrash]="true" [key]="key" hintTranslationPrefix="packages.ibexsmart.hints"
               jsonPointerKey="/ibexApp" translationPrefix="packages.ibexsmart"></smart-input>
</ng-template>

<page-content>
  <ng-container *ngIf="myPackage?.ibexApp">
    <div class="col">
      <mat-card appearance="outlined">
        <mat-card-title>{{'packages.ibexsmart.general' | translate}}</mat-card-title>
        <ng-container *ngFor="let key of generalFieldNames">
          <ng-container *ngTemplateOutlet="ibexsmartFormField;context:{ key }"></ng-container>
        </ng-container>
      </mat-card>
      <mat-card appearance="outlined">
        <mat-card-title>{{'packages.ibexsmart.login' | translate}}</mat-card-title>
        <ng-container *ngFor="let key of accountSettingsFieldsNames">
          <ng-container *ngTemplateOutlet="ibexsmartFormField;context:{ key }"></ng-container>
        </ng-container>
      </mat-card>
    </div>
    <div class="col">
      <mat-card appearance="outlined">
        <mat-card-title>{{'packages.ibexsmart.styling' | translate}}</mat-card-title>
        <ng-container *ngFor="let key of styleFieldNames">
          <ng-container *ngTemplateOutlet="ibexsmartFormField;context:{ key }"></ng-container>
        </ng-container>
      </mat-card>
    </div>
  </ng-container>
  <div class="button-right-container">
    <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{'general.save' | translate}}</button>
  </div>
</page-content>
